import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    statusIcon: {
        color: theme.palette.common.white
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginLeft: 20
    },
}));

export {useStyles};
